angular.module('smartorg.r6.mgmts.portfolioPermissions').directive('portfolioPermissions', [function () {
        return {
            restrict: 'E',
            template: require('../../template/portfolio-permission.html'),
            scope: {
                astro: '=?',
                showAlert: '&?'
            },
            link: function (scope) {
                /**
                 * Wrap the showAlert function to a easier call.
                 *
                 * @param type
                 * @param title
                 * @param message
                 */
                var showMessage = function (type, title, message) {
                    scope.showAlert({
                        type: type,
                        title: title,
                        message: message
                    });
                };
                /**
                 * Wrap angular apply thingy.
                 */
                var applyChange = function () {
                    setTimeout(function () {
                        scope.$apply();
                    });
                };
                // Create a alert method if not passed in.
                if (!scope.showAlert) {
                    scope.showAlert = function (input) {
                        alert(input.message);
                    };
                }
                // Check api status
                if (!scope.astro) {
                    showMessage('danger', 'System Error', 'Failed to load API.');
                }
                scope.groups = {};
                scope.acl = {};
                /**
                 * Set permission for a group on clicking radio buttons.
                 * @param group {{}} Group object.
                 * @param permission {string} Key of permissions, can be
                 *     'admin', 'editor', 'viewer', or 'none'.
                 */
                scope.setPermission = function (group, permission) {
                    group.permission = permission;
                    scope.checkSave();
                };
                /**
                 * See if current change needs to be saved. Keep an array
                 * of permissions for groups on loading. Check if this
                 * array changed to determine.
                 */
                scope.checkSave = function () {
                    var toCheck = scope.groups.map(function (gp) {
                        return gp.permission;
                    });
                    scope.saveEnabled = !isArrayEqual(toCheck, scope.checkAclList);
                };
                /**
                 * Save permissions to database through api call.
                 */
                scope.savePermissions = function () {
                    var newAcl = {
                        "group": {
                            "portfolioAdmins": [],
                            "editors": [],
                            "viewers": []
                        }
                    };
                    for (var i = 0; i < scope.groups.length; i++) {
                        if (scope.groups[i].permission === 'admin') {
                            newAcl.group.portfolioAdmins.push(scope.groups[i]._id);
                        }
                        else if (scope.groups[i].permission === 'editor') {
                            newAcl.group.editors.push(scope.groups[i]._id);
                        }
                        else if (scope.groups[i].permission === 'viewer') {
                            newAcl.group.viewers.push(scope.groups[i]._id);
                        }
                    }
                    scope.astro.setAcl(scope.treeId, newAcl).then(function () {
                        scope.checkAclList = scope.groups.map(function (gp) {
                            return gp.permission;
                        });
                        scope.saveEnabled = false;
                        applyChange();
                        showMessage('success', 'Success!', "Permission setting is saved.");
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                /**
                 * Load chosen groups, then load permissions on success.
                 */
                scope.loadData = function () {
                    scope.astro.getListOfChosenGroups(scope.treeId).then(function (rs) {
                        scope.groups = rs;
                        scope.loadPermissions();
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                /**
                 * Load permissions from database.
                 */
                scope.loadPermissions = function () {
                    scope.astro.getAcl(scope.treeId).then(function (rs) {
                        scope.acl = rs;
                        scope.bindGroupPermission();
                        applyChange();
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                /**
                 * Due to the strange data structure, I rebind all
                 * necessary information to groups for further access.
                 *
                 * Maybe the acl list & index can do this trick instead
                 * of modifying the groups.
                 */
                scope.bindGroupPermission = function () {
                    var aclGroup = scope.acl.group;
                    scope.checkAclList = [];
                    for (var i = 0; i < scope.groups.length; i++) {
                        if (aclGroup.portfolioAdmins.indexOf(scope.groups[i]._id) >= 0) {
                            scope.groups[i].permission = 'admin';
                        }
                        else if (aclGroup.editors.indexOf(scope.groups[i]._id) >= 0) {
                            scope.groups[i].permission = 'editor';
                        }
                        else if (aclGroup.viewers.indexOf(scope.groups[i]._id) >= 0) {
                            scope.groups[i].permission = 'viewer';
                        }
                        else {
                            scope.groups[i].permission = 'none';
                        }
                        scope.checkAclList.push(scope.groups[i].permission);
                    }
                };
                /**
                 * Handle loading things.
                 */
                scope.$on('manage:PORTFOLIO_PERMISSIONS', function (event, args) {
                    scope.treeId = args.treeId;
                    scope.loadData();
                });
                /**
                 * Check if the acl array has been changed or not.
                 * Due to the unique groups, the order of each permission
                 * matters on this comparation.
                 *
                 * @param array1 {Array<string>}
                 * @param array2 {Array<string>}
                 * @returns {boolean} True if two are exactly the same.
                 *     (including element order)
                 */
                var isArrayEqual = function (array1, array2) {
                    if (!array1 && !array2) {
                        return true;
                    }
                    else if (!array1 || !array2) {
                        return false;
                    }
                    if (array1.length != array2.length) {
                        return false;
                    }
                    else {
                        var a = array1;
                        var b = array2;
                        var len = a.length;
                        for (var i = 0; i < len; i++) {
                            if (a[i] !== b[i]) {
                                return false;
                            }
                        }
                        return true;
                    }
                };
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }
]);
//# sourceMappingURL=portfolio-permission-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/portfolio-permissions/app/js/plumbing/portfolio-permission-directive.js